<template>
    <div class="mgt-16">
        <div class="t-body3">
            {{$t('479')}}
            <!-- 카드 정보 입력 -->
        </div>

        <div class="mgt-16">
            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                id="cardNumberEl"
            >
                <i class="material-icons mdc-text-field__icon">
                </i>
                <input type="text" class="mdc-text-field__input"
                    maxlength="50" 
                    autocomplete="off"
                    v-validate="'required'"
                    name="cardNumber"                    
                    v-model="cardNumber"
                    ref="cardNumber"
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('500')}}
                            <!-- 카드번호 -->
                        </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
            </div>
            
        </div>

        <div class="payment-credit-add">
            <div>
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    id="expireDateEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                    </i>
                    <input type="text" class="mdc-text-field__input"
                        maxlength="50" 
                        autocomplete="off"
                        v-validate="'required'"
                        name="expireDate"
                        v-model="expireDate"
                        @input="inputValidThru"
                        ref="expireDate"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{$t('501')}}
                                <!-- 유효기간 (MM/YY) -->
                            </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
                
            </div>

            <div>

                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    id="cvvEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                    </i>
                    <input type="text" class="mdc-text-field__input"
                        maxlength="5" 
                        autocomplete="off"
                        v-validate="'required'"
                        name="cvv"
                        v-model="cvv"
                        ref="cvv"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{$t('502')}}
                                <!-- CVC -->
                            </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
                <div class="t-helper text-helper">
                    <span>
                        {{$t('503')}}
                        <!-- 카드 뒷면 3자리 -->
                    </span>
                </div>
                
            </div>
            
        
        </div>
        
        <div class="mgt-16">
            <button class="mdc-button mdc-button--raised btn-red" @click="addCreditCard()">
                {{$t('504')}}
                <!-- 확인 -->
            </button>
            <button class="mdc-button btn-white mgr-8 mgl-8" @click="toggleAddCardForm()">
                {{$t('505')}}
                <!-- 취소 -->
            </button>
        </div>

    </div>
</template>

<script>
/**
 * 구매하기 - 카드 등록 컴포넌트(sales - regist card component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import salesApi  from '@/api/salesApi.js'

export default {
    data() {
        return {
            cardNumber: '',
            year: '',
            month: '',
            cvv: '',
            expireDate: ''
        }
    },
    computed: {
       
    },
    mounted(){
        let cardNumberEl = new MDCTextField(document.getElementById('cardNumberEl'))
        let expireDateEl = new MDCTextField(document.getElementById('expireDateEl'))
        let cvvEl = new MDCTextField(document.getElementById('cvvEl'))
        
        const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
            let button = new MDCRipple.attachTo(el)
            return button
        })

        // 자동 유효성 체크 제거(use native validation off)
        cardNumberEl.useNativeValidation = false
        expireDateEl.useNativeValidation = false
        cvvEl.useNativeValidation = false
    },
    methods: {
        // toggle card form
        toggleAddCardForm() {
            this.$emit('toggleAddCardForm')
        },

        // validation Card expiration date
        inputValidThru({type, target}) {
            
            // replace 함수를 사용하여 슬래시( / )을 공백으로 치환한다.(Replace the forward slash (/) with a space using the replace function.)
            let replaceCard = target.value.replace(/\//g, "");

            // 텍스트박스의 입력값이 4~5글자 사이가 되는 경우에만 실행한다.(It is executed only when the input value of the text box is between 4 and 5 characters.)
            if(replaceCard.length >= 4 && replaceCard.length < 5) {

                let inputMonth = replaceCard.substring(0, 2);    // 선언한 변수 month에 월의 정보값을 담는다.(Contains the month's information value in the declared variable month.)
                let inputYear = replaceCard.substring(2, 4);       // 선언한 변수 year에 년의 정보값을 담는다.(Contains the year's information value in the declared variable year.)

                // 현재 날짜 값을 구한다.(Get the current date value.)
                let nowDate = new Date();
                let nowMonth = this.autoLeftPad(nowDate.getMonth() + 1, 2);
                let nowYear = this.autoLeftPad(nowDate.getFullYear().toString().substr(2, 2), 2);


                // isFinite함수를 사용하여 문자가 선언되었는지 확인한다.(Check if a character is declared using the isFinite function.)
                if(isFinite(inputMonth + inputYear) == false) {
                    target.value = this.autoLeftPad((Number(nowMonth) + 1), 2) + "/" + nowYear;
                    return false;
                }

                // 입력한 월이 12월 보다 큰 경우(If the month entered is greater than December)
                if(inputMonth > 12) {
                    //alert("12월보다 큰 월수는 입력하실 수 없습니다. ");
                    target.value = "12/" + inputYear;
                    return false;
                }



                // 입력한 유효기간을 현재날짜와 비교하여 사용 가능 여부를 판단한다.(The entered validity period is compared with the current date to determine whether it can be used.)
                if((inputYear + inputMonth) <= (nowYear + nowMonth)) {
                    //alert("유효기간이 만료된 카드는 사용하실 수 없습니다.");
                    target.value = inputMonth + "/" + this.autoLeftPad((Number(nowYear) + 1), 2);
                    return false;
                }

                // target.value = inputMonth + "/" + inputYear;
                this.expireDate = inputMonth + "/" + inputYear;
                this.month = inputMonth
                this.year = '20' + inputYear
            }
        },

        // 1자리 문자열의 경우 앞자리에 숫자 0을 자동으로 채워 00형태로 출력하기위한 함수(Function to automatically fill in the number 0 in the case of a 1-digit string and output it in the form of 00)
        autoLeftPad(num, digit) {
            if(String(num).length < digit) {
                num = new Array(digit - String(num).length + 1).join('0') + num
            }
            return num
        },

        // regist card
        addCreditCard() {
            let params = {
                cardNumber: this.cardNumber,
                year: this.year,
                month: this.month,
                cvv: this.cvv
            }

            salesApi.salesCreditcardInsert(params).then((response) => {
                let responseData = response.data.data
                console.log('salesCreditcardList', responseData);
                this.toggleAddCardForm()
                this.$emit('fatchCreditCard')

            }).catch((err) => {
                this.$alert({
                    title: this.$t('50025'), //'카드등록 오류',
                    content: this.$t('50026'), //'카드정보가 잘못되었습니다. 확인 후 다시 시도해주세요.',
                    accept:  this.$t('50027'), //'확인',
                }).then(() => {
                    return
                })
            })

        }
    }
}
</script>